import { useEffect, useState } from "react"
import { intComma } from "humanize-plus"
import classnames from "classnames"
import Spinner from "shared/components/spinner"
import { formatHexColorValue } from "shared/lib/alternate_brand_color"
import { pluralizeStepType } from "shared/lib/utils"
import { fetchSteps } from "./api"
import { StepMetrics } from "./types"

import styles from "./service_analytics.module.scss"

const Steps = ({
  serviceModuleName,
  serviceName,
  stepType,
}: {
  serviceModuleName: string
  serviceName: string
  stepType: string
}) => {
  const [loading, setLoading] = useState(true)
  const [metrics, setMetrics] = useState({} as StepMetrics)

  useEffect(() => {
    fetchSteps(stepType, serviceModuleName)
      .then(({ simple_service_metrics }: { simple_service_metrics: StepMetrics }) => {
        setMetrics(simple_service_metrics)
      })
      .catch(() => {
        window.appendFlash("Failed to fetch analytics metrics for this service", "danger")
      })
      .finally(() => setLoading(false))
  }, [])

  return loading ? (
    <Spinner />
  ) : (
    <>
      <div className={styles["step-module"]}>
        <div className={classnames(styles["stat-box"], styles.rounded)}>
          <p className="txt-body-3">
            Users with enabled Applets using {serviceName}'s {pluralizeStepType(stepType)}
          </p>
          <h3>{intComma(metrics.users_with_enabled_step_applets)}</h3>
          <p className={styles["stat-description"]}>
            Current total. Each user is counted once, however many Applets they have
          </p>
        </div>
        <div className={classnames(styles["stat-box"], styles.rounded)}>
          <p className="txt-body-3">
            Applets using any of {serviceName}'s {pluralizeStepType(stepType)}
          </p>
          <h3>{intComma(metrics.applets_with_service_steps)}</h3>
          <p className={styles["stat-description"]}>Current total of published and private Applets, enabled or not</p>
        </div>
      </div>
      <div className={styles["step-header"]}>
        <h3>Usage</h3>
        <p className="txt-body-3">
          All-time count of Applet enables for each of {serviceName}'s {pluralizeStepType(stepType)}. Every enable
          counts, including the same user enabling several Applets, and the count does not go down when an Applet is
          disabled. These numbers can be higher than the current user total above.
        </p>
      </div>
      <div className={styles.steps}>
        <ul className="web-applet-cards tqa">
          {metrics.step_metrics.map(({ step: { name }, users_with_enabled_step_applets }, i) => (
            <li
              className={classnames("my-web-applet-card web-applet-card web-applet-card-template tqa", styles.step)}
              key={i}
            >
              <div
                className="web-applet-card applet-card-body tqa"
                style={{ backgroundColor: formatHexColorValue(metrics.channel.brand_color) }}
              >
                <div className="tqa">
                  <p>{intComma(users_with_enabled_step_applets)} Applet enables</p>
                  <span className={styles["step-name"]}>{name}</span>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </>
  )
}

export default Steps
